import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../auth/ProtectedRoute';
import AdminRoute from '../auth/AdminRoute';
import StaffRoute from '../auth/StaffRoute';
import ProductAdminRoute from '../auth/ProductAdminRoute';

// Layouts
import PublicLayout from '../layouts/public/PublicLayout';
import UserLayout from '../layouts/user/UserLayout';
import AdminLayout from '../layouts/admin/AdminLayout';

// Public Pages
import Home from '../pages/public/Home';
import ProductList from '../pages/public/ProductList';
import ProductDetails from '../pages/public/ProductDetails';
import CheckoutResult from '../pages/public/CheckoutResult';
import Category from '../pages/public/Category';
import Login from '../pages/public/Login';
import Register from '../pages/public/Register';
import InfoPage from '../pages/public/InfoPage';

// User Pages
import UserDashboard from '../pages/user/Dashboard';
import Profile from '../pages/user/Profile';
import Cart from '../pages/user/Cart';
import Wishlist from '../pages/user/Wishlist';
import UserOrders from '../pages/user/Orders';
import PaymentMethods from '../pages/user/PaymentMethods';
import DeliveryAddresses from '../pages/user/DeliveryAddresses';
import Settings from '../pages/user/Settings';

// Admin Pages
import AdminDashboard from '../pages/admin/Dashboard';
import Products from '../pages/admin/Products';
import CreateProduct from '../pages/admin/CreateProduct';
import EditProduct from '../pages/admin/EditProduct';
import Users from '../pages/admin/Users';
import Orders from '../pages/admin/Orders';
import SiteSettings from '../pages/admin/SiteSettings';
import Carousels from '../pages/admin/Carousels';
import MainPage from '../pages/admin/MainPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductList />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/checkout/success" element={<CheckoutResult kind="success" />} />
        <Route path="/checkout/fail" element={<CheckoutResult kind="fail" />} />
        <Route path="/category/:slug" element={<Category />} />
        <Route path="/about-us" element={<InfoPage />} />
        <Route path="/privacy-policy" element={<InfoPage />} />
        <Route path="/contact" element={<InfoPage />} />
        <Route path="/payments" element={<InfoPage />} />
        <Route path="/warranty" element={<InfoPage />} />
        <Route path="/delivery" element={<InfoPage />} />
        <Route path="/terms-and-conditions" element={<InfoPage />} />
        <Route path="/faq" element={<InfoPage />} />
        <Route path="/user/cart" element={<Cart />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* User Routes */}
      <Route
        element={
          <ProtectedRoute>
            <UserLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/user/dashboard" element={<UserDashboard />} />
        <Route path="/user/profile" element={<Profile />} />
        <Route path="/user/wishlist" element={<Wishlist />} />
        <Route path="/user/orders" element={<UserOrders />} />
        <Route path="/user/payments" element={<PaymentMethods />} />
        <Route path="/user/addresses" element={<DeliveryAddresses />} />
        <Route path="/user/settings" element={<Settings />} />
      </Route>

      {/* Admin Routes */}
      <Route
        element={
          <AdminRoute>
            <AdminLayout />
          </AdminRoute>
        }
      >
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/main-page" element={<MainPage />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/settings" element={<SiteSettings />} />
        <Route path="/admin/carousels" element={<Carousels />} />
      </Route>

      <Route
        element={
          <ProductAdminRoute>
            <AdminLayout />
          </ProductAdminRoute>
        }
      >
        <Route path="/admin/products" element={<Products />} />
        <Route path="/admin/products/create" element={<CreateProduct />} />
        <Route path="/admin/products/:id/edit" element={<EditProduct />} />
      </Route>

      <Route
        element={
          <StaffRoute>
            <AdminLayout />
          </StaffRoute>
        }
      >
        <Route path="/admin/orders" element={<Orders />} />
        <Route path="/admin/orders/:view" element={<Orders />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
